import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { services } from "../data/siteData";
import useScrollAnimation from "../hooks/useScrollAnimation";
import "./Services.css";

export default function Services() {
  const [activeId, setActiveId] = useState(services[0].id);
  const active = services.find((s) => s.id === activeId);

  const sectionRef = useScrollAnimation(({ gsap, el }) => {
    gsap.from(el.querySelectorAll(".services__item"), {
      x: -30,
      opacity: 0,
      duration: 0.7,
      stagger: 0.08,
      ease: "power3.out",
      scrollTrigger: { trigger: el, start: "top 75%" },
    });
  }, []);

  return (
    <section id="services" className="services section" ref={sectionRef}>
      <div className="container">
        <span className="eyebrow">Shared Across Both Locations</span>
        <h2 className="services__title">
          WHAT WE <span className="glow-text">POWER</span>
        </h2>

        <div className="services__grid">
          <ul className="services__list" onMouseLeave={() => setActiveId(activeId)}>
            {services.map((service) => (
              <li
                key={service.id}
                className={`services__item ${
                  activeId === service.id ? "services__item--active" : ""
                }`}
                onMouseEnter={() => setActiveId(service.id)}
                onFocus={() => setActiveId(service.id)}
                tabIndex={0}
              >
                <span className="services__item-number">{service.number}</span>
                <span className="services__item-name">{service.name}</span>
                <p className="services__item-short">{service.short}</p>
              </li>
            ))}
          </ul>

          <div className="services__visual">
            <AnimatePresence mode="wait">
              <motion.div
                key={active.id}
                className="services__visual-panel"
                initial={{ opacity: 0, scale: 1.04, filter: "blur(8px)" }}
                animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                exit={{ opacity: 0, scale: 0.98, filter: "blur(8px)" }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              >
                <div className="services__visual-glow" />
                <div className="services__visual-info">
                  <span className="services__visual-number">{active.number}</span>
                  <h3>{active.name}</h3>
                  <p>{active.description}</p>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>
  );
}
